import React from 'react';
import { Logo } from 'shared/_ui';
import { ThemeSwitcher } from 'features/ThemeSwitcher';
import { UserProfileDropdown } from 'features/UserProfileDropdown';
import styles from './styles.module.scss';
import { Faq } from 'features/Faq';
import { LanguageSwitch } from 'features/SwitchLanguage';

const Header: React.FC = () => {
  return (
    <div className={styles.header}>
      <Logo size="middle" redirect />
      <nav className={styles.nav}>
        <Faq />
        <ThemeSwitcher />
        <UserProfileDropdown languageSwitcherSlot={<LanguageSwitch />} />
      </nav>
    </div>
  );
};

export { Header };
